
import { computed, defineComponent, ref } from 'vue'
import {
  PermissionDetail,
  PermissionFeMap,
  ServicePermissionService, toSubscribeByPriceId
} from '@/services/service-permission.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { countdownDay } from '@/utils/time'
import { ServiceType } from '@/views/dashboard/_enum/service-type'
import { isObjectEmpty } from '@/utils/tool'

export default defineComponent({
  props: {
    normalPermissionKey: {
      type: String,
      default: ''
    },
    linuxPermissionKey: {
      type: String,
      default: ''
    }
  },
  setup (props, context) {
    const injector = useReflectiveInjector([])
    const servicePermissionService = injector.get(ServicePermissionService)

    const normalPermissionInfo = ref({} as PermissionDetail)
    const linuxPermissionInfo = ref({} as PermissionDetail)
    const normalPermissionConfig = ref({} as PermissionDetail)
    const linuxPermissionConfig = ref({} as PermissionDetail)

    const permissionKey = computed(() => {
      return props.normalPermissionKey || props.linuxPermissionKey
    })

    const permissionInfo = computed(() => {
      return isObjectEmpty(normalPermissionInfo.value) ? linuxPermissionInfo.value : normalPermissionInfo.value
    })

    servicePermissionService.rightsMap.subscribe(() => {
      normalPermissionInfo.value = servicePermissionService.getPermissionInfo(props.normalPermissionKey)
      linuxPermissionInfo.value = servicePermissionService.getPermissionInfo(props.linuxPermissionKey)
    })

    servicePermissionService.allRightsMap.subscribe(() => {
      normalPermissionConfig.value = servicePermissionService.getAllPermissionInfo(props.normalPermissionKey)
      linuxPermissionConfig.value = servicePermissionService.getAllPermissionInfo(props.linuxPermissionKey)
    })

    const isShowExperience = computed(() => {
      if (props.normalPermissionKey && !props.linuxPermissionKey) {
        return normalPermissionInfo.value.type === ServiceType.experience
      } else if (!props.normalPermissionKey && props.linuxPermissionKey) {
        return linuxPermissionInfo.value.type === ServiceType.experience
      } else if (props.normalPermissionKey && props.linuxPermissionKey) {
        return normalPermissionInfo.value.type === ServiceType.experience && linuxPermissionInfo.value.type === ServiceType.experience
      }
    })

    const isShowExpire = computed(() => {
      if (props.normalPermissionKey && !props.linuxPermissionKey) {
        return isObjectEmpty(normalPermissionInfo.value)
      } else if (!props.normalPermissionKey && props.linuxPermissionKey) {
        return isObjectEmpty(linuxPermissionInfo.value)
      } else if (props.normalPermissionKey && props.linuxPermissionKey) {
        return isObjectEmpty(normalPermissionInfo.value) && isObjectEmpty(linuxPermissionInfo.value)
      }
    })

    function toSubscribe () {
      toSubscribeByPriceId({
        normal_price_id: normalPermissionConfig.value.price_id,
        linux_price_id: linuxPermissionConfig.value.price_id,
      })
    }

    return {
      ServiceType,
      PermissionFeMap,
      permissionKey,
      permissionInfo,
      normalPermissionInfo,
      linuxPermissionInfo,
      normalPermissionConfig,
      linuxPermissionConfig,
      isShowExperience,
      isShowExpire,
      toSubscribe,
      countdownDay,
      isObjectEmpty,
    }
  }
})
